<template>
  <div class="page">
    <div class="page__bd" style="height: 100%;">
        <div class="weui-tab">
            <div class="weui-tab__panel">
                <router-view></router-view>
            </div>
            <div class="weui-tabbar e-tabbar">
                <router-link to="/recharge" replace class="weui-tabbar__item weui-bar__item_on">
                    <span style="display: inline-block;position: relative;">
                        <img src="../assets/recharge.png" alt="" class="weui-tabbar__icon">
                        <!-- <span class="weui-badge" style="position: absolute;top: -2px;right: -13px;">8</span> -->
                    </span>
                    <!-- <p style="color:#363fa3" class="weui-tabbar__label">充值</p> -->
                </router-link>
                <router-link to="/history" replace class="weui-tabbar__item">
                    <img src="../assets/log.png" alt="" class="weui-tabbar__icon">
                    <!-- <p style="color:#363fa3" class="weui-tabbar__label">充值记录</p> -->
                </router-link>
                <router-link to="/use_history" replace class="weui-tabbar__item">
                    <img src="../assets/use_history.png" alt="" class="weui-tabbar__icon">
                    <!-- <p style="color:#363fa3" class="weui-tabbar__label">充值记录</p> -->
                </router-link>
                <router-link to="/mine" replace class="weui-tabbar__item">
                    <span style="display: inline-block;position: relative;">
                        <img src="../assets/mine.png" alt="" class="weui-tabbar__icon">
                        <!-- <span class="weui-badge weui-badge_dot" style="position: absolute;top: 0;right: -6px;"></span> -->
                    </span>
                    <!-- <p style="color:#363fa3" class="weui-tabbar__label">我的</p> -->
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'container',
  components: {
  }
}
</script>

<style scoped>
.e-tabbar{
  bottom: 0px;
  position: fixed;
  width: 100%;
}
.page{
    margin-bottom: 40px
}
</style>
